import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface FilterableContentLayoutProps {
  children: ReactNode;
  filters: ReactNode;
  isFiltersOpen: boolean;
  className?: string;
  contentClassName?: string;
  sidebarLabel?: string;
}

export const FilterableContentLayout = ({
  children,
  filters,
  isFiltersOpen,
  className,
  contentClassName,
  sidebarLabel,
}: FilterableContentLayoutProps) => {
  return (
    <div
      className={cn(
        "flex items-start",
        isFiltersOpen ? "gap-4" : "gap-0",
        className,
      )}
    >
      <aside
        aria-hidden={!isFiltersOpen}
        aria-label={sidebarLabel}
        className={cn(
          "shrink-0 overflow-hidden transition-[width,opacity] duration-200",
          isFiltersOpen ? "w-80 opacity-100" : "w-0 opacity-0",
        )}
        inert={!isFiltersOpen}
      >
        <div
          className={cn(
            "h-full w-80 origin-left transition-transform duration-200",
            isFiltersOpen ? "scale-x-100" : "pointer-events-none scale-x-95",
          )}
        >
          {filters}
        </div>
      </aside>

      <div className={cn("min-w-0 flex-1", contentClassName)}>{children}</div>
    </div>
  );
};
